module.exports = __webpack_public_path__ + "img/20200623_benovelty_taptab_boutir.56909552.jpg";